import Model from "@/lib/model/model";

export class VirConfig extends Model {
  virId = 0;
}
